import { render, staticRenderFns } from "./SettingReviewer.vue?vue&type=template&id=a54febc0&scoped=true&lang=html&"
import script from "./SettingReviewer.vue?vue&type=script&lang=js&"
export * from "./SettingReviewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54febc0",
  null
  
)

export default component.exports